import { IAddPlacementForm } from './interfaces';

export const ALI_ID = 1;

export const DEFAULT_VALUES: IAddPlacementForm = {
    url: '',
    offer: undefined,
    trafficSource: undefined,
    trafficSourceCategory: 1,
};

export const SOCIAL_CATEGORY_ID = 1;
export const WEBSITE_CATEGORY_ID = 2;

export const OFFERS_LIMIT = 5;
export const DEFAULT_SOURCES_COUNT = 5;
